module.exports = __webpack_public_path__ + "static/img/exam_preview.2f9ee3f2.png";